import React, { useState, useEffect, useContext } from 'react'
import Select from '../../components/Select'
import Input from '../../components/Input'
import styled from 'styled-components'
import app from '../../firebase/config'
import api from '../../services/api'
import Button from 'react-bootstrap/Button';

import { ToastContainer, toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import { PagesContext } from '../../context/pages'
import TextAreaPage from '../../components/TextAreaPage'


const CardInput = styled.section`

    display: flex;
    width: 100%;
    margin-bottom: 0.9em;


    input,select{
        width: 100%;
        height: 50px;
        border-radius: 10px;
    }

    div > label{
        font-size: 0.9rem;
    }

    .textPrimary{
        color: black;
        font-family: "Poppins";
        font-weight: 500;
        margin-bottom: 0rem;
        font-size: 1.2rem;
    }

    div{
        margin-right:1.5rem;
    }

    @media screen and (max-width:720px){
        flex-direction: column;
        div{
            margin-left: 0rem;
        }

    }


`
const CardData = styled.div`
    display:flex;
    justify-content:center;
    flex-direction: column;
    align-items: center;

    div > select{
        width: 100%;
    }

`
const CardWrapper = styled.section`
    background-color: #fafafa;
    display: flex;

   
    .colum_primary{ 
        flex:0.1;
    }


    .colum_secondary{
        padding: 1.7rem;

        display: flex;
        flex:1;
        height: 100vh;
        flex-direction: column;
        width: 100%;
    }

    @media screen and (max-width:720px){
    .colum_primary{ 
        flex:0;

    }

        .colum_secondary{
        display: flex;
        flex:1;
        flex-direction: column;
        width: 100%;
    }
    }

`
const FixWidthSidebar = styled.div`
    display: block;
    width: 130px;
    @media screen and (min-width:1800px){
        display: block;
        width: 90px;
    }

    @media screen and (max-width:820px){
        display: none;
    }


`
const CardTextArea = styled.div`
    margin-top:1.2rem;
    p{
        margin-right: 1rem;
        font-family: "Poppins";
        font-weight: 400;
        font-style: normal;
        margin-bottom: 0.9rem;
    }
`
const PreviewBanner = styled.div`
   p{
        margin-right: 1rem;
        font-family: "Poppins";
        font-weight: 400;
        font-style: normal;
        margin-bottom: 0.9rem;
    }
`
const BannerImage = styled.img`
    object-fit: contain;
    width: 100%;
    height: 320px;
    object-fit: cover;

    

`
const ModalEditPage = ({ props }) => {
    const { getAllPages, dataPage } = useContext(PagesContext)
    const [imagePreview, setImagePreview] = useState()
    const [pageName, setPageName] = useState()
    const [buttonName, setButtonName] = useState()
    const [description, setDescription] = useState()
    const [imageFirebase,setImageFirebase] = useState()
    const [buttons, setButtons] = useState([])
    const [page] = useState([
        {
            name_page: "",
            name: "",
            image: "",
            description: "",

        }
    ])
    const handleInput = (name, value) => {

        page[0][name] = value

    }
    const handleSave = async () => {

        await storageImages()
        getAllPages()


    }
    const storageImages = async () => {

        

        const loadingToastId = toast.loading("Processando Página...");
        return app.storage().ref(`/pages/images/${page[0].name}`).put(page[0].image)
            .then(() => {
                console.log(`Imagem ${page[0].name} carregada com sucesso`);
                return app.storage().ref(`/pages/images/${page[0].name}`).getDownloadURL();
            })
            .then(image => {

                return api.put("pages/update",{
                    name_page:pageName,
                    button_name:buttonName,
                    description:localStorage.getItem("@CONTENT_DESCRIPTION_PAGE"),
                    image:image,
                    id:dataPage[0].id
                })
        
                

            })
            .catch(error => {
                console.error(`Erro ao carregar a imagem ${page[0].name}:`, error);
            });


    }
    const getData = async () => {
        const response = await api.get("buttons/get/all")
        setButtons(response.data)
    }
    const edit = async () => {

        if(page[0].image){

            const { type } = page[0].image

            const supportedTypes = ["image/png", "image/jpg", "image/jpeg"]
            const verifySupportedType = supportedTypes.includes(type)


            if (!verifySupportedType) {
                return toast.error("Formato de imagem não suportado!")
            }
            await storageImages()
            window.location.href="/dashboard/pages"

        }

        const response = await api.put("pages/update",{
            name_page:pageName,
            button_name:buttonName,
            description:localStorage.getItem("@CONTENT_DESCRIPTION_PAGE"),
            id:dataPage[0].id
        })


        if(response.status == 200){
            window.location.href="/dashboard/pages"
        }
    }
    useEffect(() => {
        getData()
    }, [])

    useEffect(() => {
        if (dataPage) {
            setPageName(dataPage[0].name_page)
            setButtonName(dataPage[0].button_name)
            setDescription(dataPage[0].description)
            setImagePreview(dataPage[0].image)
        }

    }, [dataPage])
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Editar página
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <CardInput>
                    <Input name={"Nome da página *"} onChange={(e) => setPageName(e.target.value)} value={pageName} />
                </CardInput>
                <CardInput>
                    <Select name="Botão da página *" data={buttons} target={"name"} editValue={buttonName} onChange={(e) => setButtonName(e.target.value)} />
                    <Input name={"Banner da página *"} accept={".png, .jpg, .jpeg"} onChange={(e) => handleInput("image", e.target.files[0])} type={"file"} />
                </CardInput>
                <CardData>
                    {imagePreview

                        ?
                        <PreviewBanner>
                            <p>Preview Banner*</p>
                            <BannerImage src={imagePreview} />
                        </PreviewBanner>
                        :
                        <></>
                    }

                    <CardTextArea>
                        <p>Descrição da página *</p>
                        <TextAreaPage description={description} type={"update"} />
                    </CardTextArea>
                </CardData>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => edit()}>Editar</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalEditPage